import styles from './TimeBar.module.css';
import TaskDoneIcon from "../../assets/svgs/taskdone.svg";

const TimeBar = ({ tasks, selectedDate, admin, isMobile, isModal, isReassignModal, hideAvatar }) => {
  if (!selectedDate) return null;

  const tasksWithStartTime = tasks.filter(task => task.Inicio && task.Inicio !== "00:00:00");
  const tasksWithoutStartTime = tasks.filter(task => !task.Inicio || task.Inicio === "00:00:00");

  const sortedWithTime = [...tasksWithStartTime].sort((a, b) => a.sortStart - b.sortStart);
  const sortedWithoutTime = [...tasksWithoutStartTime].sort((a, b) => a.Tarea.localeCompare(b.Tarea));
  const sortedTasks = [...sortedWithTime, ...sortedWithoutTime];

  const totalMinutes = sortedTasks.reduce((sum, task) => sum + task.Minutos, 0);
  const referenceMinutes = totalMinutes > 480 ? totalMinutes : 480;

  const completedTasks = sortedTasks.filter(task => task.Hecho === 1).length;
  const totalTasks = sortedTasks.length;

  const doneMinutes = sortedTasks
    .filter(t => t.Hecho === 1)
    .reduce((sum, t) => sum + t.Minutos, 0);

  const remainingMinutes = Math.max(0, totalMinutes - doneMinutes);

  const fmt = (m) => `${Math.floor(m / 60)}h y ${m % 60}min`;

  return (
    <div
      className={`
        ${styles.timeBarContainer}
        ${isMobile && isModal ? styles.timeBarContainerModal : ""}
        ${isMobile && !isModal ? styles.timeBarContainerMobile : ""}
        ${isMobile && admin ? styles.timeBarContainerMobileAdmin : ""}
        ${isReassignModal ? styles.timeBarContainerReassign : ""}
      `}
    >
      <div className={styles.timeBar}>
        {sortedTasks.map((task, index) => {
          const widthPercentage = (task.Minutos / referenceMinutes) * 100;
          return (
            <div
              key={index}
              className={styles.timeSegment}
              style={{ backgroundColor: task.color, width: `${widthPercentage}%` }}
            />
          );
        })}
      </div>

      <div className={isMobile ? styles.timeInfoMobile : styles.timeInfo}>
        <div
          className={
            isReassignModal
              ? (isMobile ? styles.taskSummaryReassignModalMobile : styles.taskSummaryReassignModal)
              : styles.taskSummary
          }
          style={admin && !hideAvatar && !isModal && !isReassignModal ? { marginLeft: "20px" } : {}}
        >
          <img src={TaskDoneIcon} alt="Tareas realizadas" className={styles.taskDoneIcon} />
          {isMobile ? `${completedTasks} de ${totalTasks}` : `Tareas realizadas ${completedTasks} de ${totalTasks}`}
        </div>

        {admin ? (
          <div className={styles.totalTime}>
            {isMobile ? (
              <span className={styles.timerMobile}>{fmt(totalMinutes)}</span>
            ) : (
              <>
                Tiempo total asignado:{" "}
                <span className={styles.timer}>{fmt(totalMinutes)}</span>
              </>
            )}
          </div>
        ) : (
          <div className={styles.totalTime}>
            {isMobile ? (
              <>
                <div>
                  Tiempo restante{" "}
                  <span className={styles.timer}>{fmt(remainingMinutes)}</span>
                </div>
                <div className={styles.timerDone}>
                  Total asignado{" "}
                  <span className={styles.timerDoneTime}>{fmt(totalMinutes)}</span>
                </div>
              </>
            ) : (
              <>
                <div>
                  Tiempo restante{" "}
                  <span className={styles.timer}>{fmt(remainingMinutes)}</span>
                </div>
                <div className={styles.timerDone}>
                  Total asignado{" "}
                  <span className={styles.timer}>{fmt(totalMinutes)}</span>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeBar;
